import { createI18n } from 'vue-i18n'

// Traduções incluídas no build (geradas por `php artisan i18n:export`)
import builtTranslations from './translations.json'

function detectLocale() {
    const urlParams = new URLSearchParams(window.location.search)
    const langParam = urlParams.get('lang')

    const localeMap = {
        pt: 'pt_BR',
        es: 'es',
        en: 'en',
        fr: 'fr',
        it: 'it',
        zh: 'zh',
    }

    if (langParam && localeMap[langParam]) {
        return localeMap[langParam]
    }

    try {
        const inertiaEl = document.getElementById('app')
        if (inertiaEl && inertiaEl.dataset.page) {
            const pageData = JSON.parse(inertiaEl.dataset.page)
            const detectedLanguage = pageData?.props?.detectedLanguage
            if (detectedLanguage && localeMap[detectedLanguage]) {
                return localeMap[detectedLanguage]
            }
        }
    } catch (e) {}

    return 'pt_BR'
}

// Configuração do i18n com todas as traduções já carregadas
const i18n = createI18n({
    legacy: false,
    locale: 'pt_BR',
    fallbackLocale: 'pt_BR',
    messages: builtTranslations,
    globalInjection: true,
})

export function setupI18n() {
    const locale = detectLocale()
    i18n.global.locale.value = locale
    return Promise.resolve(i18n)
}

export async function updateLocale(newLocale = null) {
    const localeMap = {
        pt: 'pt_BR',
        es: 'es',
        en: 'en',
        fr: 'fr',
        it: 'it',
        zh: 'zh',
    }

    const locale = newLocale ? (localeMap[newLocale] || newLocale) : detectLocale()

    if (i18n.global.locale.value !== locale) {
        i18n.global.locale.value = locale
    }
}

export default i18n
